import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import DateOfBirth from 'features/application/screens/DateOfBirth/DateOfBirth';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DateOfBirthWrapper = () => {
  const {
    prefillData,
    prefillDataFetching,
    prefillDataError,
    refetch: refetchPrefillData,
    reactivationApplicationId,
  } = useReactivationPrefillData();

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_PERSONAL_INFO,
  });

  const { t: translatedText } = useTranslation('reactivation', {
    keyPrefix: 'personalInfo',
  });

  return (
    <DateOfBirth
      prefilledDateOfBirth={prefillData?.dateOfBirth as string}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      reExecuteQuery={refetchPrefillData}
      fetching={prefillDataFetching}
      error={prefillDataError as Error}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      buttonLabel={translatedText('buttons.save')}
      nextRoute="/reactivation/review-info"
      backRoute="/reactivation/review-info"
      isReactivation
    />
  );
};

export default DateOfBirthWrapper;
